import Icon from 'veui/components/Icon'

Icon.register({
  'file-html': {
    paths: [
      {
        fill: '#fc7909',
        d: 'M27.68 9.8l-6.66-8a1.34 1.34 0 00-1.03-.48H6a2 2 0 00-2 2v25.34c0 1.1.9 2 2 2h20a2 2 0 002-2v-18c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#ffb169',
        d: 'M21.02 1.8a1.34 1.34 0 00-1.03-.48v7.34c0 1.1.9 2 2 2h6c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#fff',
        d: 'M12.83 15.39v.96c0 .4-.23.75-.57.93L9.08 18.9l3.18 1.62c.34.18.57.53.57.93v.97a.42.42 0 01-.61.37l-5.53-2.87a.63.63 0 01-.34-.55v-.93a.6.6 0 01.33-.55l5.54-2.87a.42.42 0 01.6.37zm4.97-2.03h-.7a.83.83 0 00-.8.64l-2.4 10.02v.08c0 .19.15.33.33.33h.7c.4 0 .72-.27.81-.63l2.39-10.03v-.07a.33.33 0 00-.33-.34zm7.5 4.52l-5.53-2.86a.42.42 0 00-.6.37v.96c-.01.4.22.75.55.93l3.2 1.62-3.2 1.62c-.33.18-.56.53-.56.93v.97a.42.42 0 00.61.37l5.53-2.87c.2-.1.34-.31.34-.55v-.93a.62.62 0 00-.34-.56z'
      }
    ],
    width: '32',
    height: '32'
  }
})
